import { Session } from '@wharfkit/session'
import { PermissionLevel, PrivateKey } from '@wharfkit/antelope'
import { WalletPluginEmbedded } from '@properwallet/wallet-core'
import { wharf } from '@properwallet/chain-eos'

/**
 * Build a WharfKit Session for the embedded private-key wallet (Fuel + AutoCorrect from SessionKit).
 */
export function createSessionFromPrivateKey(privateKeyWif: string, accountName: string): Session {
  const kit = wharf.sessionKit
  if (!kit) throw new Error('SessionKit not initialized')
  const chain = kit.chains[0]
  if (!chain) throw new Error('No chain configured')
  const embeddedPlugin = new WalletPluginEmbedded()
  embeddedPlugin.setPrivateKey(PrivateKey.from(privateKeyWif))
  const permissionLevel = PermissionLevel.from({ actor: accountName, permission: 'active' })
  return new Session(
    { chain, permissionLevel, walletPlugin: embeddedPlugin },
    {
      appName: kit.appName,
      fetch: kit.fetch,
      transactPlugins: kit.transactPlugins,
      transactPluginsOptions: kit.transactPluginsOptions,
      ui: kit.ui,
    },
  )
}
